const HostApprovals = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Host Approvals</h1>
        <p className="text-gray-600">Host approval functionality coming soon...</p>
      </div>
    </div>
  );
};

export default HostApprovals;

